import React, {useState, useEffect} from 'react';
import Fab from '@mui/material/Fab';
import ThemeFigcaption from '../ThemeFigcaption';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, Scrollbar, Pagination, Navigation, Mousewheel, EffectFade } from 'swiper/modules';
import {ProgressiveImage} from '../ProgressiveImage';
import {ImageZoom} from './ModalZooms';
import { ArrowBackIos, ArrowForwardIos, } from '@mui/icons-material';

import 'swiper/css';
import 'swiper/css/autoplay';
import 'swiper/css/scrollbar';
import 'swiper/css/pagination';
import 'swiper/css/navigation';
import 'swiper/css/mousewheel';
import 'swiper/css/free-mode';
import 'swiper/css/mousewheel';

 
function ModalGallery({modal, open}) {
    const  {id} = modal;
    const {play, loop, speed, delay, medias} = modal.content;
    const [swiper, setSwiper] = useState(null);

    const pauseOnInit = (swiper) => {
        if(modal.content.play === true) {
            swiper.autoplay.stop();
        }
    }

      
    useEffect(() => {

        if(!swiper) {
            const swiperEl = document.getElementById('swiper-'+modal.id);
            
            if(swiperEl) {
                setSwiper(swiperEl.swiper);
            }
        }

    });

    useEffect(() => {
        if(swiper && open === true) {

            switch(true) {
                case true === play && (false === swiper.autoplay.running || true === swiper.autoplay.paused) :
                    swiper.autoplay.start();
                break;
                case false === play && true === swiper.autoplay.running :
                    swiper.autoplay.pause();
                break;
                
            }
   
        }
    }, [swiper, open, play]);

    return(
        <Swiper 
            id={'swiper-'+id}
            modules={[Autoplay, Scrollbar, Pagination, Navigation, Mousewheel, EffectFade]}
            effect="fade"
            fadeEffect={{crossFade: true }}
            slidesPerView={1}
            loop={loop}
            style={{height:"100%","--swiper-pagination-color": "#170fd6"}}
            autoplay={play ? {
                delay:delay,
                speed:speed,
                disableOnInteraction:true,
            } : false}
            /*pagination={{
                clickable: true,
                dynamicBullets: true,
            }}*/
            navigation={{
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            }}
            mousewheel={{
                enabled:true,
            }}
            onInit={(swiper) => {pauseOnInit(swiper)}}
            spaceBetween={20}>
            {medias && medias.map((image, index) => {
                const template = image.template ? image.template : null;
                return (
                <SwiperSlide key={`${modal.id}-${index}`} data-caption={image.figcaption} style={{display:"flex",flexDirection:"column" ,alignItems:"center",justifyContent:"center"}}>
                    {(template === 'zoom' || template === 'iframe') ?
                        <>
                            {template === 'zoom' && 
                            <div className="flex flex-col md:flex-row md:justify-center mx-auto overflow-hidden bg-[#f3f4f6] p-[12px] sm:p-[24px] sm:mb-[24px] sm:gap-[24px]">
                            <ImageZoom media={image} modalFigcaption={image.figcaption} style={{paddingBottom:'24px'}} />
                            </div>}
                            {template === 'iframe' &&  
                            <div style={{position:"relative",paddingBottom:"calc(100svh - 280px)", height:0, width:"100%"}} className="mb-[24px]">
                                <iframe src={image.src} title={image.figcaption} style={{position:"absolute",top:0, left:"24px",height:"100%",width:"100%",maxWidth:"1100px", maxHeight:"calc(100svh - 280px)"}} allowFullScreen={true} loading="lazy" referrerPolicy="no-referrer-when-downgrade"/>
                            </div>}
                        </>
                        :
                        <ProgressiveImage
                            datas={image}
                            className="w-auto h-auto max-w-full max-h-full object-contain mx-auto pb-6"
                            progressSx={{width:"100%", margin:"auto", padding:"0"}}
                            style={{maxHeight:"calc(100% - 48px)"}}
                        />
                    }
                        <div style={{maxWidth:"100%",textAlign:"center",display:"flex",alignItems:"center",justifyContent:"center"}}>
                        {image.figcaption && 
                            ThemeFigcaption({figcaptionText:image.figcaption})
                        }
                        </div>
                </SwiperSlide>
                )
            })}
            <div className="swiper-button-prev shadow-lg" style={buttonStyle}>
                <Fab sx={{height:"36px",width:"36px"}} size="small" color="default">
                    <ArrowBackIos sx={{ fontSize: 20 }} style={prevArrowStyle} />
                </Fab> 
            </div>
            <div className="swiper-button-next shadow-lg" style={buttonStyle}>
                <Fab sx={{height:"36px",width:"36px"}} size="small" color="default">
                    <ArrowForwardIos sx={{ fontSize: 'inherit' }} style={nextArrowStyle} />
                </Fab>
            </div>
        </Swiper>
    )
}

const buttonStyle = {
    backgroundColor: 'transparent',
    width: '36px',
    height: '36px',
    boxShadow: 'unset'
};

const prevArrowStyle = {
    width: '20px',
    height: '20px',
    transform: "translateX(3px)"
};

const nextArrowStyle = {
    width: '20px',
    height: '20px',
};

export default ModalGallery;